var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C5B928BB-5391-4B4F-A5DF-541D45BC0005") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footers-#1",
    transform: "translate(-1323.000000, -511.000000)",
    fill: "#D8BE8D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copyright",
    transform: "translate(0.000000, 485.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-links",
    transform: "translate(1130.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.367347,3.48325359 L207.382896,3.9354067 C207.382896,8.6076555 204.070943,14 198.037901,14 C196.187561,14 194.461613,13.4138756 193,12.4090909 C193.264334,12.4425837 193.528669,12.4593301 193.793003,12.4593301 C195.332362,12.4593301 196.747328,11.9066986 197.866861,10.9521531 C196.420797,10.9186603 195.223518,9.89712919 194.803693,8.49043062 C195.005831,8.54066986 195.207969,8.55741627 195.410107,8.55741627 C195.721088,8.55741627 196.000972,8.50717703 196.280855,8.44019139 C194.772595,8.10526316 193.653061,6.68181818 193.653061,4.97368421 L193.653061,4.92344498 C194.088435,5.19138756 194.601555,5.34210526 195.130224,5.35885167 C194.259475,4.72248804 193.66861,3.6507177 193.66861,2.42822967 C193.66861,1.77511962 193.83965,1.1722488 194.119534,0.636363636 C195.736638,2.77990431 198.162293,4.18660287 200.883382,4.33732057 C200.836735,4.0861244 200.805637,3.80143541 200.805637,3.53349282 C200.805637,1.57416268 202.26725,0 204.086492,0 C205.034985,0 205.874636,0.418660287 206.48105,1.10526316 C207.227405,0.954545455 207.927114,0.653110048 208.564626,0.251196172 C208.315841,1.08851675 207.802721,1.77511962 207.118562,2.21052632 C207.787172,2.12679426 208.424684,1.94258373 209,1.65789474 C208.564626,2.36124402 208.004859,2.98086124 207.367347,3.48325359 L207.367347,3.48325359 Z",
    id: "twitter-icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.73da164446b00a16a72d0bd5f21750d9.svg";
export { ForwardRef as ReactComponent };